// extracted by mini-css-extract-plugin
module.exports = {"informer":"GLaa3","body":"GLaa5","pointer":"GLaa7","text":"GLah","cross":"GLtj"};